/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_New_ChatInputs */



/**
* | output |
* | --- |
* | "New chat" |
*
* @param {Assistant_New_ChatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_new_chat = /** @type {((inputs?: Assistant_New_ChatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_New_ChatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle conversation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Chat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova chat")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый чат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo chat")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新聊天")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいチャット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई चैट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo bate-papo")
	return /** @type {LocalizedString} */ ("New chat")
});